import React, { useEffect } from 'react';

import { Container, Pagination } from '@mui/material';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import classes from './NgzCustomersDashboardScanIq.module.scss';
import { TitleRow } from './TItleRow/TitleRow';
import { angularizeWithProviders } from '../../../shared/providers';
import { scanIqCustomerListStore } from '../../stores/scanIqCustomersListStore';
import { FilterRow } from './FilterRow/FilterRow';
import { EmptyList, PageTitle } from '../../../shared/components/ui-components';
import { CustomerRow } from './CustomerRow/CustomerRow';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { AddNewScanIqCustomerButton } from './AddNewScanIqCustomerButton/AddNewScanIqCustomerButton';

const NgzCustomersDashboardScanIq = observer(() => {
  const { getCustomerList, filterMethods, customerList } = scanIqCustomerListStore;
  const { isSuperAdmin } = loggedInUserDataStore;

  const {
    totalElements,
    isShowPagination,
    isShowPlaceholder,
    isSearchUsed,
    getPaginationProps,
    setDefaultValues,
  } = filterMethods;

  useEffect(() => {
    getCustomerList();

    return () => {
      setDefaultValues();
    };
  }, []);

  const tableClassNames = classNames(classes.customersTable, {
    [classes.extraColumn]: isSuperAdmin,
  });

  const paginationProps = getPaginationProps();

  return (
    <Container>
      <PageTitle title={`Customer Communication (${totalElements})`}>
        <AddNewScanIqCustomerButton />
      </PageTitle>
      <div className={tableClassNames}>
        <TitleRow />
        <FilterRow />
        {customerList.map((customer) => (
          <CustomerRow
            key={`${customer.id}-${customer.entityId}`}
            customerInfo={customer}
          />
        ))}
      </div>
      <EmptyList
        show={isShowPlaceholder}
        isSearch={isSearchUsed}
        description="There are no customers"
      />
      {isShowPagination && <Pagination {...paginationProps} />}
    </Container>
  );
});

angularizeWithProviders(NgzCustomersDashboardScanIq, 'ngzCustomersDashboardScanIq', {});
